module.exports = __webpack_public_path__ + "img/update-box.5d6b3a21.png";